import { fromBase64 } from '@aws-sdk/util-base64'
import styled from '@emotion/styled'
import AgoraRTC, { DeviceInfo } from 'agora-rtc-sdk-ng'
import { AnimatePresence, motion } from 'framer-motion'
import { encode } from 'js-base64'
import { ChangeEvent, useCallback, useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast'
import { useUpdateEffect } from 'react-use'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'

import { changePicUpdate, checkPicList } from '@/api/room'
import just_icon_img from '@/assets/images/just/just_icon.png'
import just_icon_d_img from '@/assets/images/just/just_icon_d.png'
import assess_active_icon_img from '@/assets/images/room/control/assess_active_icon.png'
import assess_normal_icon_img from '@/assets/images/room/control/assess_normal_icon.png'
import captions_active_icon_img from '@/assets/images/room/control/captions_active_icon.png'
import captions_normal_icon_img from '@/assets/images/room/control/captions_normal_icon.png'
import classPage_img from '@/assets/images/room/control/classPage.png'
import classPage_d_img from '@/assets/images/room/control/classPage_d.png'
import correct_disabled_icon_img from '@/assets/images/room/control/correct_disabled_icon.png'
import correct_normal_icon_img from '@/assets/images/room/control/correct_normal_icon.png'
import course_active_icon_img from '@/assets/images/room/control/course_active_icon.png'
import course_disabled_icon_img from '@/assets/images/room/control/course_disabled_icon.png'
import course_normal_icon_img from '@/assets/images/room/control/course_normal_icon.png'
import flower_disabled_icon_img from '@/assets/images/room/control/flower_disabled_icon.png'
import flower_icon_img from '@/assets/images/room/control/flower_icon.png'
import pen_active_icon_img from '@/assets/images/room/control/pen_active_icon.png'
import pen_normal_icon_img from '@/assets/images/room/control/pen_normal_icon.png'
import pen_style_disabled_img from '@/assets/images/room/control/pen_style_disabled.png'
import pen_style_normal_img from '@/assets/images/room/control/pen_style_normal.png'
import praise_disabled_icon_img from '@/assets/images/room/control/praise_disabled_icon.png'
import praise_icon_img from '@/assets/images/room/control/praise_icon.png'
import record_active_icon_img from '@/assets/images/room/control/record_active_icon.png'
import record_disabled_icon_img from '@/assets/images/room/control/record_disabled_icon.png'
import sun_disabled_icon_img from '@/assets/images/room/control/sun_disabled_icon.png'
import sun_icon_img from '@/assets/images/room/control/sun_icon.png'
import sync_active_icon_img from '@/assets/images/room/control/sync_active_icon.png'
import sync_disabled_icon_img from '@/assets/images/room/control/sync_disabled_icon.png'
import sync_icon_img from '@/assets/images/room/control/sync_icon.png'
import sync_icon_d_img from '@/assets/images/room/control/sync_icon_d.png'
import sync_normal_icon_img from '@/assets/images/room/control/sync_normal_icon.png'
import voice_close_icon_img from '@/assets/images/room/control/voice_close_icon.png'
import voice_normal_icon_img from '@/assets/images/room/control/voice_normal_icon.png'
import watch_icon_img from '@/assets/images/room/control/watch_icon.png'
import watch_icon_d_img from '@/assets/images/room/control/watch_icon_d.png'
import close_img from '@/assets/images/room/drawingboard/close.png'
import delete_img from '@/assets/images/room/drawingboard/delete.png'
import pen1_img from '@/assets/images/room/drawingboard/pen1.png'
import pen2_img from '@/assets/images/room/drawingboard/pen2.png'
import pen3_img from '@/assets/images/room/drawingboard/pen3.png'
import pen4_img from '@/assets/images/room/drawingboard/pen4.png'
import pen5_img from '@/assets/images/room/drawingboard/pen5.png'
import recall_img from '@/assets/images/room/drawingboard/recall.png'
import recover_img from '@/assets/images/room/drawingboard/recover.png'
import configImg from '@/assets/images/student/config@2x.png'
import just_screen_btn from '@/assets/images/student/just-screen-btn.png'
import micImg from '@/assets/images/student/mic@2x.png'
import mic_disabledImg from '@/assets/images/student/mic-disabled@2x.png'
import screen_btn_img from '@/assets/images/student/screen-btn.png'
import tool_upload from '@/assets/images/student/tool-upload.png'
import Modal from '@/components/Modal'
import useGetRecoilState from '@/hooks/useGetRecoilState'
import { captionsState, courseAssessState, CoursewareList, coursewareListState, lineColorState, lineWidthState, penStateState, viewPicIdIndexState, viewPicIdState } from '@/store/courseware'
import {
  audioLiveState,
  bigTeaAScreenState,
  bigWinState,
  correctionState,
  drawMethodModalState,
  drawMethodState,
  isStuOnlineState,
  justUserState,
  paramsState,
  pictureViolationState,
  restState,
  roomReadyState,
  SyncState,
  syncStateState,
  useDeviceState
} from '@/store/room'
import { Board } from '@/utils/board'
import Rtc, { SettingDevices, UseDeviceName } from '@/utils/rtc'
import { Network, VolumeType } from '@/utils/rtc/agora'
import uploadClient from '@/utils/upload-client'

import { bigWindow, roomEvent, rtcClient, rtmClient } from '../..'
import { coursewareBoard } from '../Courseware'
import JustScreen from '../JustScreen'
import NetworkLine from '../Network/Line'
import Screen from '../Screen'
import { justStudentVideoBoard, mainStudentVideoBoard, viceStudentVideoBoard } from '../Video/components/Student'
import { viceTeacherVideoBoard } from '../Video/components/Teacher'
import { justTeacherVideoBoard, mainTeacherVideoBoard } from '../Video/TeacherVideo'

export type BoardAction = 'prev' | 'next' | 'close' | 'del' | 'lineWidth' | 'lineColor'
export type RewardType = 'praise' | 'flower' | 'sun' | 'willEnd' | 'alarmClock' | 'courseRight'

const lineColors = ['#E02020', '#FFB500', '#6DD400', '#0091FF', '#000000']
const lineWidths = [20, 16, 12, 6, 3]
const defAnimate = {
  initial: { opacity: 0, x: '6vh' },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: '6vh' },
  transition: {
    duration: 0.15,
    type: 'spring',
    damping: 35,
    stiffness: 600
  }
}

const tabs = [
  { title: '设备设置', value: 'setting' },
  { title: '网络质量', value: 'net' }
]

export default function Index() {
  const [lineWidth, setLineWidth] = useRecoilState(lineWidthState)
  const [lineColor, setLineColor] = useRecoilState(lineColorState)
  const [active, setActive] = useState('')
  const [audioLive, setAudioLive] = useRecoilState(audioLiveState)
  const [coursewareList, setCoursewareList] = useRecoilState(coursewareListState)
  const [volumeLevel, setVolumeLevel] = useState(0) // 0 ~ 100
  const timer = useRef<any>(null)
  const uploadRef = useRef<HTMLInputElement>(null)
  const [viewPicId, setViewPicId] = useRecoilState(viewPicIdState)
  const [brushAuthModal, setBrushAuthModal] = useState(false)
  const [courseModal, setCourseModal] = useState(false)
  const [courseSelectState, setCourseSelectState] = useState(false)
  const [captions, setCaptions] = useRecoilState(captionsState)
  const [penState, setPenState] = useRecoilState(penStateState)
  const [courseAssess, setCourseAssess] = useRecoilState(courseAssessState)
  const setCorrection = useSetRecoilState(correctionState)
  const viewPicIdIndex = useRecoilValue(viewPicIdIndexState)
  const params = useRecoilValue(paramsState)
  const isStuOnline = useRecoilValue(isStuOnlineState)
  const [syncState, setSyncState, getSyncState] = useGetRecoilState(syncStateState)
  const [bigWin, setBigWin] = useRecoilState(bigWinState)
  const [bigTeaAScreen, setBigTeaAScreen] = useRecoilState(bigTeaAScreenState)
  const [justUser, setJustUser] = useRecoilState(justUserState)
  const roomReady = useRecoilValue(roomReadyState)
  const [rest, setRest] = useRecoilState(restState)
  const [pictureViolation, setPictureViolation] = useRecoilState(pictureViolationState)
  const [hideSetting, setHideSetting] = useState(false)
  const [useDevice, setUseDevice] = useRecoilState(useDeviceState)
  const [exitModalState, setExitModalState] = useState(false)
  const [settingModalState, setSettingModalState] = useState(false)
  const [timeStr, setTimeStr] = useState('00:00:00')
  const [settingDevices, setSettingDevices] = useState<SettingDevices[]>([])
  const [drawMethod, setDrawMethod] = useRecoilState(drawMethodState)
  const [drawMethodModal, setDrawMethodModal] = useRecoilState(drawMethodModalState)
  const toastIdRef = useRef('')
  const volumesRef = useRef<VolumeType[]>([])
  const networkRef = useRef<Network | null>(null)
  const [tab, setTab] = useState(tabs[0].value)

  useEffect(() => {
    getDevices()
    AgoraRTC.onCameraChanged = getDevices
    AgoraRTC.onMicrophoneChanged = getDevices
    AgoraRTC.onPlaybackDeviceChanged = getDevices
    rtcClient.on('volume-indicator', volumeIndicator)
    rtmClient.on('ArtSayBye', ArtSayBye)
    rtmClient.on('ArtSyncScreen', ArtSyncScreen)
    roomEvent.on('rest-state', closeSetting)
    return () => {
      rtcClient.removeListener('volume-indicator', volumeIndicator)
      rtmClient.removeListener('ArtSayBye', ArtSayBye)
      rtmClient.removeListener('ArtSyncScreen', ArtSyncScreen)
      roomEvent.removeListener('rest-state', closeSetting)
      timer.current && clearTimeout(timer.current)
    }
  }, [])

  const getDevices = (deviceInfo?: DeviceInfo) => {
    if (deviceInfo) {
      toastIdRef.current && toast.remove(toastIdRef.current)
      toastIdRef.current = toast('检测到设备变动')
    }
    Rtc.getSettingDevices().then((res) => setSettingDevices(res))
  }

  useEffect(() => {
    boardAction('lineWidth')
  }, [lineWidth])

  useEffect(() => {
    boardAction('lineColor')
  }, [lineColor])

  const volumeIndicator = useCallback((volumes: VolumeType[]) => {
    const volume = volumes.find((v) => v.uid === params.mainTeacherId)
    if (volume) {
      setVolumeLevel(volume.level)
      timer.current = setTimeout(() => {
        setVolumeLevel((v) => v / 2)
      }, 500)
    }
  }, [])

  const ArtSayBye = useCallback((memberId: string, payload: any) => {
    const { userInfo } = payload
    const { userId, userType } = userInfo || {}
    if (userType && Number(userType) === 3) return
    // 老师离开房间，隐藏上传课件按钮(收回授权)
    setPenState(true)
  }, [])

  const ArtSyncScreen = useCallback((memberId: string, payload: any) => {
    const { imageInfo, touserid, frameDic, state } = payload
    const frame = JSON.parse(window.atob(frameDic))

    const keys: string[] = Object.keys(frame)
    const values: string[] = Object.values(frame)

    const baseClientInfo: string = values.shift() || ''
    const id: number = Number(keys[values.indexOf(baseClientInfo) + 1])

    if (imageInfo?.picId) {
      const { picId, lines } = imageInfo
      setViewPicId(picId)
    }
    const syncState = getSyncState()
    if (state === 1 && syncState !== 'active') {
      toast('切换至同屏模式')
      console.log('同屏 :>> ', '同屏')
      setSyncState('active')
    }
    console.log('ArtSyncScreen id', id)
    // 那个窗口处于大屏 1课件 2老师b 3学员a 4学员b 老师a默认左侧大屏
    // 1 是课件
    if (id === 1) {
      setBigTeaAScreen(false)
      setBigWin(1)
    }
    // 2远端主要主摄像头
    if (id === 2) {
      // setBigWin(2)
      setBigTeaAScreen(true)
    }
    // 3是远副
    if (id === 3) {
      setBigTeaAScreen(false)
      setBigWin(2)
    }
    // 4是主摄像头
    if (id === 4) {
      setBigTeaAScreen(false)
      setBigWin(3)
    }
    // 5是副
    if (id === 5) {
      setBigTeaAScreen(false)
      setBigWin(4)
    }
  }, [])
  console.log('bigWin', bigWin, bigTeaAScreen)
  const changeMute = () => {
    if (!audioLive.mainStudent) {
      rtcClient
        .deviceOn('audio')
        .then(() => {
          toast.success('已开启麦克风')
        })
        .catch((e) => {
          toast.error(e || '开启麦克风失败')
        })
    } else {
      rtcClient
        .deviceOff('audio')
        .then(() => {
          toast.success('已关闭麦克风')
        })
        .catch((e) => {
          toast.error(e || '关闭麦克风失败')
        })
    }
  }

  // const changeVideoMute = () => {
  //   if (videoLive.mainTeacher === 2) {
  //     rtcClient
  //       .deviceOn('mainVideo')
  //       .then(() => {
  //         toast.success('已开启主摄像头')
  //       })
  //       .catch((e) => {
  //         toast.error(e || '开启主摄像头失败')
  //       })
  //   } else {
  //     rtcClient
  //       .deviceOff('mainVideo')
  //       .then(() => {
  //         toast.success('已关闭主摄像头')
  //       })
  //       .catch((e) => {
  //         toast.error(e || '关闭主摄像头失败')
  //       })
  //   }
  // }

  const boardAction = (action: BoardAction) => {
    let windowId, board: Board
    if (bigWin === 1) {
      windowId = viewPicId
      board = coursewareBoard
    } else {
      const teacherJustShow = justUser[params.mainTeacherId]
      const shudentJustShow = justUser[params.mainStudentId]
      switch (bigWin) {
        case 2:
          board = teacherJustShow ? justTeacherVideoBoard : mainTeacherVideoBoard
          windowId = board.windowId
          break
        case 3:
          board = viceTeacherVideoBoard
          windowId = board.windowId
          break
        case 4:
          board = shudentJustShow ? justStudentVideoBoard : mainStudentVideoBoard
          windowId = board.windowId
          break
        case 5:
          board = viceStudentVideoBoard
          windowId = board.windowId
          break
      }
    }
    switch (action) {
      case 'prev':
        board.clear(1, windowId, false)
        // rtmClient.sendMessage('ArtClearLine', {
        //   windowId,
        //   userId: params.teacherId.toString(),
        //   action: 1
        // })
        break
      case 'next':
        board.clear(2, windowId, false)
        // rtmClient.sendMessage('ArtClearLine', {
        //   windowId,
        //   userId: params.teacherId.toString(),
        //   action: 2
        // })
        break
      case 'close':
        setActive('')
        break
      case 'del':
        board.clear(3)
        // rtmClient.sendMessage('ArtClearLine', {
        //   windowId,
        //   userId: params.teacherId.toString(),
        //   action: 3,
        //   fromId: params.teacherId.toString()
        // })
        break
      case 'lineWidth':
        mainStudentVideoBoard.setConf({ lineWidth })
        viceStudentVideoBoard.setConf({ lineWidth })
        justStudentVideoBoard.setConf({ lineWidth })
        mainTeacherVideoBoard.setConf({ lineWidth })
        viceTeacherVideoBoard.setConf({ lineWidth })
        justTeacherVideoBoard.setConf({ lineWidth })
        coursewareBoard.setConf({ lineWidth })
        break
      case 'lineColor':
        mainStudentVideoBoard.setConf({ brushColor: lineColor })
        viceStudentVideoBoard.setConf({ brushColor: lineColor })
        justStudentVideoBoard.setConf({ brushColor: lineColor })
        mainTeacherVideoBoard.setConf({ brushColor: lineColor })
        viceTeacherVideoBoard.setConf({ brushColor: lineColor })
        justTeacherVideoBoard.setConf({ brushColor: lineColor })
        coursewareBoard.setConf({ brushColor: lineColor })
        break
    }
    // 初始化=3时，dom渲染，这里useEffect的lineColor、lineWidth会引起发送信令，但是这时信令要还未初始化
    // 默认的Effect确实不应该发送信令？但是需要执行白板的赋值？
    // 添加roomReady的合理性？TODO？
    if (roomReady && (action === 'lineColor' || action === 'lineWidth')) {
      // rtmClient.sendMessage('ArtPenStyle', {
      //   color: lineColor.replace('#', ''),
      //   lineWidth: lineWidth
      // })
    }
  }

  const uploadChange = async (e: ChangeEvent<HTMLInputElement>) => {
    setCourseModal(false)
    const files: any = e.target.files
    if (files?.length) {
      let typeErr = false
      for (const file of files) {
        const fileTypeExp = /(\.png|\.jpg|\.jpeg)$/i
        if (!fileTypeExp.test(file.name)) {
          typeErr = true
        }
      }
      if (typeErr || files.length > 20) {
        uploadRef.current && (uploadRef.current.value = '')
        toast.error(typeErr ? '请选择png、jpg、jpeg格式的图片文件' : '选择的图片数量请在20张以内')
        return
      }

      uploadClient
        .fileUpload(files)
        .then(async (result: any) => {
          console.info(result)
          const done = result.filter((v: any) => v) as CoursewareList[]
          const errLen = result.length - done.length
          const txt = `${done.length}个课件上传成功${errLen ? `,${errLen}个课件上传失败` : ''}`
          if (errLen) {
            toast(txt)
          } else {
            toast.success(txt)
          }
          if (done.length) {
            const list = done.map((item) => item.picUrl)
            const listRes = await checkPicList({
              picList: list,
              userid: params.teacherId.toString()
            })
            const {
              data: { failList, successList, warterfailList }
            } = listRes
            if (successList.length) {
              const newList: CoursewareList[] = []
              done.forEach((item) => {
                if (successList.includes(item.picUrl)) {
                  newList.push(item)
                }
              })
              const newCoursewareList = [...coursewareList, ...newList]
              setCoursewareList(newCoursewareList)
              const lastPic = newCoursewareList[newCoursewareList.length - 1]
              setViewPicId(lastPic.picId)

              // 同步服务端课件
              rtmClient.sendMessage('ArtPicSelecte', {
                images: newList,
                videos: []
              })

              // 埋点接口,正式课
              // if (params.lessonTimeId) {
              //   changePicUpdate({
              //     lessonTimeId: params.lessonTimeId,
              //     roomId: params.roomId,
              //     userId: params.teacherId.toString(),
              //     uploadPicCount: newList.length,
              //     uploadType: 2 // 统一为本地相册上传
              //   }).then((res) => {
              //     if (res.status === 0) {
              //       console.log('上传课件埋点提交成功!')
              //     }
              //   })
              // }
            }
            const textStr = []
            failList.length && textStr.push('是否有违规内容')
            warterfailList.length && textStr.push('是否有第三方水印')
            if (textStr.length) {
              setPictureViolation(textStr.join('、'))
            }
          }
        })
        .finally(() => {
          uploadRef.current && (uploadRef.current.value = '')
        })
    }
  }

  const reward = (type: RewardType) => {
    setActive('')
    if (!isStuOnline) {
      toast('对方未上线')
      return
    }
    roomEvent.emit('lottie', type)
    rtmClient.sendMessage('ArtCommandControl', {
      cmdType: 11,
      cmdBehavior: ['', 'flower', 'sun', 'praise'].indexOf(type)
    })
  }

  const brushAuthAct = () => {
    setBrushAuthModal(false)
    if (!isStuOnline) {
      toast('对方未上线，不可授权')
      return
    }
    rtmClient.sendMessage('ArtCommandControl', {
      cmdType: 2,
      cmdBehavior: 2,
      toUser: penState ? params.mainTeacherId : params.mainStudentId
    })
    // rtmClient.sendMessage('ArtPenStyle', {
    //   color: lineColor.replace('#', ''),
    //   lineWidth: lineWidth
    // })
    toast.success(penState ? '取消授权成功' : '画笔授权成功')
    setPenState((v) => !v)
  }

  const chengeSyncState = (state: SyncState) => {
    setActive('')
    if (syncState === state) return
    setSyncState(state)
    if (state === 'active') {
      // 课件 TODO
      const courseData = coursewareList[viewPicIdIndex]
      const lines = coursewareBoard.getPageLines(viewPicId)
      // rtmClient.sendMessage('ArtSyncScreen', {
      //   frameDic: fromBase64(encode(JSON.stringify({ 0: bigWindow, [bigWin]: bigWindow }))),
      //   imageInfo: {
      //     ...courseData, // 图片
      //     lines: lines, // 画线
      //     picId: viewPicId,
      //     type: 1 // 图片类型
      //   },
      //   state: 1 // 1 霸屏 2 窗口
      // })
    } else if (state === 'normal') {
      rtmClient.sendMessage('ArtCommandControl', { cmdType: 1 })
      // 学员在线则设置4 TODO
      setBigWin(3)
    } else if (state === 'classPage') {
      rtmClient.sendMessage('ArtCommandControl', { cmdType: 12 })
      setBigWin(1)
      // 课件
      const courseData = coursewareList[viewPicIdIndex]
      if (courseData) {
        const lines = coursewareBoard.getPageLines(viewPicId)
        // rtmClient.sendMessage('ArtPicChange', {
        //   imageInfo: {
        //     ...courseData,
        //     zipUrl: courseData.zip,
        //     jsonConfig: JSON.stringify(courseData.json),
        //     lines: lines
        //   }
        // })
      }
    }
  }

  useUpdateEffect(() => {
    if (syncState === 'active') {
      // 课件 TODO
      const courseData = coursewareList[viewPicIdIndex]
      const lines = coursewareBoard.getPageLines(viewPicId)
      // rtmClient.sendMessage('ArtSyncScreen', {
      //   frameDic: fromBase64(encode(JSON.stringify({ 0: bigWindow, [bigWin]: bigWindow }))),
      //   imageInfo: {
      //     ...courseData, // 图片
      //     lines: lines, // 画线
      //     picId: viewPicId,
      //     type: 1 // 图片类型
      //   },
      //   state: 1 // 1 霸屏 2 窗口
      // })
    } else if (syncState === 'normal') {
      // 学员在线则设置4 TODO
      setBigWin(3)
    } else if (syncState === 'classPage') {
      setBigWin(1)
      // 课件
      const courseData = coursewareList[viewPicIdIndex]
      if (courseData) {
        const lines = coursewareBoard.getPageLines(viewPicId)
        // rtmClient.sendMessage('ArtPicChange', {
        //   imageInfo: {
        //     ...courseData,
        //     zipUrl: courseData.zip,
        //     jsonConfig: JSON.stringify(courseData.json),
        //     lines: lines
        //   }
        // })
      }
    }
  }, [syncState])

  const closeSetting = useCallback((state: boolean) => {
    if (state) {
      setHideSetting(true)
      setSettingModalState(false)
    } else {
      setHideSetting(false)
    }
  }, [])
  const deviceChane = (key: UseDeviceName, deviceId: string) => {
    let device = { ...useDevice, [key]: deviceId }
    if (key === 'mainCamera') {
      rtcClient.changeMainCamera({ deviceId: deviceId, publish: true })
      if (deviceId && deviceId === useDevice.viceCamera) {
        rtcClient.changeViceCamera({ deviceId: useDevice.mainCamera, publish: true })
        device = { ...device, viceCamera: useDevice.mainCamera }
      }
    } else if (key === 'viceCamera') {
      rtcClient.changeViceCamera({ deviceId: deviceId, publish: true })
      if (deviceId && deviceId === useDevice.mainCamera) {
        rtcClient.changeMainCamera({ deviceId: useDevice.viceCamera, publish: true })
        device = { ...device, mainCamera: useDevice.viceCamera }
      }
    } else if (key === 'microphone') {
      rtcClient.changeMicrophone({ deviceId: deviceId, publish: true })
    } else {
      console.info('扬声器不支持变更')
    }
    setUseDevice(device)
  }

  const exit = () => {
    window.history.back()
  }

  return (
    <Container className="w-[16.875vh] h-[13.38vh] top-[82.62vh] absolute">
      <div className={`w-full grid grid-cols-[repeat(auto-fit,minmax(min-content,5vh))] gap-y-[0.9375vh] gap-x-[0.9375vh] ${rest.state !== 1 && !rest.onceRest ? '' : 'hidden'}`}>
        {/* 提词器 */}
        {/* <div onClick={() => setCaptions(!captions)} className={`w-full h-[6vh] relative anim_btn2 captions ${captions ? 'active' : ''}`}></div> */}
        {/* 模式 */}
        {/* <div className="w-full h-[6vh] relative">
          <div
            onClick={() => setActive((v) => (v === 'voice' ? '' : 'voice'))}
            className={`relative z-30 w-full h-full anim_btn2 ${syncState} check`}
          ></div>
          <AnimatePresence>
            {active === 'voice' ? (
              <motion.div {...defAnimate} className="flex justify-between items-center z-20 w-[20vh] h-full absolute right-[7vh] top-0">
                <div
                  onClick={() => chengeSyncState('normal')}
                  className={`w-[6vh] h-full anim_btn2 normal ${syncState === 'normal' ? 'check' : ''}`}
                ></div>
                <div
                  onClick={() => chengeSyncState('active')}
                  className={`w-[6vh] h-full anim_btn2 active ${syncState === 'active' ? 'check' : ''}`}
                ></div>
                <div
                  onClick={() => chengeSyncState('classPage')}
                  className={`w-[6vh] h-full anim_btn2 classPage ${syncState === 'classPage' ? 'check' : ''}`}
                ></div>
              </motion.div>
            ) : null}
          </AnimatePresence>
        </div> */}
        {/* 麦克风 */}
        <div onClick={changeMute} className={`anim_btn2 w-[5vh] h-[5vh] voice ${audioLive.mainStudent ? '' : 'close'}`}></div>
        {/* 设置 */}
        <div
          onClick={() => {
            setSettingModalState(true)
            setTab('setting')
          }}
          className={`anim_btn2 w-[5vh] h-[5vh] setting`}
        ></div>
        {/* 摄像头1 */}
        {/* <div onClick={changeVideoMute} className={`w-full h-[6vh] relative anim_btn2 voice ${videoLive.mainTeacher === 1 ? '' : 'close'}`}></div> */}
        {/* 图库 */}
        {!penState ? <div onClick={() => setCourseModal(true)} className="anim_btn2 w-[5vh] h-[5vh] course"></div> : null}
        {/* 画笔授权 */}
        {/* <div
          onClick={() => {
            if (!isStuOnline) {
              toast('对方未上线，不可授权')
              return
            }
            setBrushAuthModal(true)
          }}
          className={`w-full h-[6vh] relative anim_btn2 pen ${penState ? 'active' : ''}`}
        ></div> */}
        {/* 画笔 */}
        {/* <div className="w-full h-[6vh] relative">
          <div
            onClick={() => setActive((v) => (v === 'draw' ? '' : 'draw'))}
            className={`relative z-30 w-full h-full anim_btn2 clear ${active === 'draw' ? 'active' : ''}`}
          ></div>
          <AnimatePresence>
            {active === 'draw' ? (
              <motion.div {...defAnimate} className="z-20 w-[11vh] h-[36vh] flex flex-col justify-evenly items-center absolute right-[7vh] top-[-15.5vh] bg-[#ddd]">
                <div className="w-full h-[26vh] flex flex-center justify-evenly">
                  <div className="flex flex-col justify-evenly w-[4vh]">
                    {lineColors.map((color, i) => (
                      <div
                        key={i}
                        onClick={() => setLineColor(color)}
                        style={{ backgroundColor: color }}
                        className={`w-[4vh] h-[4vh] rounded-full anim_btn2 ${
                          lineColor === color ? 'border-sloid border-[2px] border-[#FFF]' : ''
                        }`}
                      ></div>
                    ))}
                  </div>
                  <div className="flex flex-col justify-evenly w-[4vh]">
                    {lineWidths.map((v, i) => (
                      <div
                        onClick={() => setLineWidth(v)}
                        key={v}
                        className={`w-[4vh] h-[4vh] rounded-[4px] anim_btn2 pen${i + 1} ${lineWidth === v ? 'bg-[#999]' : ''}`}
                      ></div>
                    ))}
                  </div>
                </div>
                <div className="flex-1 flex flex-wrap items-center justify-evenly">
                  <div onClick={() => boardAction('prev')} className="w-[4vh] h-[4vh] anim_btn2 prev"></div>
                  <div onClick={() => boardAction('next')} className="w-[4vh] h-[4vh] anim_btn2 exit"></div>
                  <div onClick={() => boardAction('del')} className="w-[4vh] h-[4vh] anim_btn2 del"></div>
                  <div onClick={() => boardAction('close')} className="w-[4vh] h-[4vh] anim_btn2 close"></div>
                </div>
              </motion.div>
            ) : null}
          </AnimatePresence>
        </div> */}
        {/* 试听课点评 */}
        {/* {params.lessonType === 1 && !params.isTempClass ? (
          <div
            onClick={() => {
              if (bigWin === 1) {
                setCourseAssess((v) => !v)
              } else {
                toast('请先将课件设置大屏,才能点评')
              }
            }}
            className={`w-full h-[6vh] relative anim_btn2 access ${courseAssess ? 'active' : ''}`}
          ></div>
        ) : null} */}
        {/* 奖励 */}
        {/* <div className="w-full h-[6vh] relative">
          <div
            onClick={() => setActive((v) => (v === 'reward' ? '' : 'reward'))}
            className={`relative z-30 w-full h-full anim_btn2 award ${active === 'reward' ? 'active' : ''}`}
          ></div>
          <AnimatePresence>
            {active === 'reward' ? (
              <motion.div {...defAnimate} className="flex justify-between items-center z-20 w-[20vh] h-full absolute right-[7vh] top-0">
                <div onClick={() => reward('praise')} className="w-[6vh] h-full anim_btn2 praise"></div>
                <div onClick={() => reward('flower')} className="w-[6vh] h-full anim_btn2 flower"></div>
                <div onClick={() => reward('sun')} className="w-[6vh] h-full anim_btn2 sun"></div>
              </motion.div>
            ) : null}
          </AnimatePresence>
        </div> */}
        {/* 矫正 */}
        {/* <div onClick={() => setCorrection(true)} className="w-full h-[6vh] relative anim_btn2 correct"></div> */}
        {/* just */}
        <JustScreen />
        {/* 屏幕共享 */}
        <Screen />
      </div>
      {/* 画笔权限弹窗 */}
      <Modal show={brushAuthModal} title={penState ? '收回屏幕书写和上传图片权限' : '对方将拥有屏幕书写和上传图片权限'} cancel={() => setBrushAuthModal(false)} confirm={brushAuthAct}>
        <p className="py-[20px] text-[14px]">双方屏幕同步显示，且可在屏幕上进行圈选批改等教学操作</p>
      </Modal>
      {/* 课件&上传课件弹窗 */}
      <Modal show={courseModal} footer="" title="课件管理" cancel={() => setCourseModal(false)}>
        <div className="flex justify-evenly items-start pt-[15px] pb-[5px]">
          <div className="h-full rounded-full px-[40px] py-[9px] text-[#ff3300] bg-[#ffeee8] border-[#ff3300] border-[1px] border-solid anim_btn2 relative">
            上传课件
            <input ref={uploadRef} className="text-[0] cursor-pointer absolute top-0 left-0 w-full h-full opacity-0" type="file" accept=".png,.jpg,.jpeg" multiple onChange={uploadChange} />
          </div>
        </div>
      </Modal>

      <Modal show={settingModalState} title="设置" footer="" confirm={exit} cancel={() => setSettingModalState(false)}>
        <div className="w-[400px] mt-[20px] mb-[40px] flex flex-col items-center justify-center gap-[20px]">
          {/* <div className="flex items-center p-4 w-full text-sm text-blue-800 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400" role="alert">
            <svg className="flex-shrink-0 inline w-4 h-4 mr-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
            </svg>
            <div>如需关闭摄像头或麦克风，设置为「未选择」即可</div>
          </div> */}

          <div className="flex border-b border-gray-200">
            {tabs.map((v) => (
              <button
                key={v.value}
                onClick={() => setTab(v.value)}
                className={`rounded-md first:rounded-r-none last:rounded-l-none px-4 py-2 font-medium text-sm focus:outline-none ${tab === v.value ? 'bg-slate-800 text-[#d1d1d1] hover:text-white' : 'bg-[#e1e1e1] text-gray-700 hover:text-gray-900'}`}
              >
                {v.title}
              </button>
            ))}
          </div>

          {tab === 'setting' ? (
            <>
              {settingDevices.map((v, i) => (
                <div key={i} className="w-full h-[40px] pr-[20px] text-[16px] flex items-center justify-center gap-[20px]">
                  <div className="w-[60px] h-full flex items-end justify-between flex-col">
                    <div className="flex-1 flex items-center text-right text-[16px]">{v.title}</div>
                    {v.subTitle ? <div className="text-right text-[12px] text-[#999]">{v.subTitle}</div> : null}
                  </div>
                  <div className="flex-1">
                    <select onChange={(e) => deviceChane(v.key, e.target.value)} value={useDevice[v.key]} className="h-[40px] py-0 px-[10px] text-[14px] w-full leading-[1] bg-select border-[#999]">
                      <option value="">未选择</option>
                      {v.devices.map((device, deviceIndex) => (
                        <option key={deviceIndex} value={device.deviceId}>
                          {device.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              ))}
            </>
          ) : null}
          {tab === 'net' ? <NetworkLine /> : null}
        </div>
      </Modal>
    </Container>
  )
}

const Container = styled(motion.div)`
  .award {
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url('${record_disabled_icon_img}');
    &.active {
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('${record_active_icon_img}');
    }
  }
  .sun {
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url('${sun_icon_img}');
    &.disabled {
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('${sun_disabled_icon_img}');
    }
  }

  .flower {
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url('${flower_icon_img}');
    &.disabled {
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('${flower_disabled_icon_img}');
    }
  }

  .praise {
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url('${praise_icon_img}');
    &.disabled {
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('${praise_disabled_icon_img}');
    }
  }

  .normal {
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url('${watch_icon_d_img}');
    &.check {
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('${watch_icon_img}');
    }
  }

  .active {
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url('${sync_icon_d_img}');
    &.check {
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('${sync_icon_img}');
    }
  }

  .classPage {
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url('${classPage_d_img}');
    &.check {
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('${classPage_img}');
    }
  }

  .setting {
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url('${configImg}');
  }

  .captions {
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url('${captions_normal_icon_img}');
    &.active {
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('${captions_active_icon_img}');
    }
  }

  /* 课中点评按钮 */
  .access {
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url('${assess_normal_icon_img}');
    &.active {
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('${assess_active_icon_img}');
    }
  }

  .voice {
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url('${micImg}');
    &.close {
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('${mic_disabledImg}');
    }
  }

  .course {
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url('${tool_upload}');
    &.active {
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('${course_active_icon_img}');
    }
    &.disabled {
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('${course_disabled_icon_img}');
    }
  }

  .pen {
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url('${pen_normal_icon_img}');
    &.active {
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('${pen_active_icon_img}');
    }
  }

  /* .sync {
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url('${sync_normal_icon_img}');
    &.active {
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('${sync_active_icon_img}');
    }
    &.disabled {
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('${sync_disabled_icon_img}');
    }
  } */

  .clear {
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url('${pen_style_disabled_img}');
    &.active {
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('${pen_style_normal_img}');
    }
  }

  .correct {
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url('${correct_normal_icon_img}');
    &.disabled {
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('${correct_disabled_icon_img}');
    }
  }

  .screen {
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url('${screen_btn_img}');
    &.disabled {
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('${screen_btn_img}');
    }
  }

  .just {
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url('${just_screen_btn}');
    &.disabled {
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('${just_icon_img}');
    }
  }

  .pen1 {
    background-image: url('${pen1_img}');
    background-size: contain;
    background-repeat: no-repeat;
  }

  .pen2 {
    background-image: url('${pen2_img}');
    background-size: contain;
    background-repeat: no-repeat;
  }

  .pen3 {
    background-image: url('${pen3_img}');
    background-size: contain;
    background-repeat: no-repeat;
  }

  .pen4 {
    background-image: url('${pen4_img}');
    background-size: contain;
    background-repeat: no-repeat;
  }

  .pen5 {
    background-image: url('${pen5_img}');
    background-size: contain;
    background-repeat: no-repeat;
  }

  .prev {
    background-image: url('${recall_img}');
    background-size: contain;
    background-repeat: no-repeat;
  }

  .exit {
    background-image: url('${recover_img}');
    background-size: contain;
    background-repeat: no-repeat;
  }

  .del {
    background-image: url('${delete_img}');
    background-size: contain;
    background-repeat: no-repeat;
  }

  .close {
    background-image: url('${close_img}');
    background-size: contain;
    background-repeat: no-repeat;
  }
`
